import React from 'react';
import {Box, ButtonBase, IconButton, Typography} from '@mui/material';
import {Close, DateRangeOutlined} from '@mui/icons-material';
import {alpha} from '@mui/material/styles';
import moment from 'moment-timezone';
import {getSettingsColors, settingsInputStyles} from '../settings/SettingsDesign';

export const dateRangePopoverStyles = {
    ...settingsInputStyles,
    borderRadius: '16px', boxShadow: 'none', border: '1px solid', borderColor: 'divider',
    bgcolor: theme => getSettingsColors(theme).card, backgroundImage: 'none', color: 'text.primary',
    maxWidth: 'calc(100vw - 16px)', maxHeight: 'calc(100% - 16px)',
    '& .MuiTextField-root': {m: 0, minWidth: 0},
    '& .MuiOutlinedInput-root': {bgcolor: theme => theme.palette.mode === 'light' ? theme.palette.background.paper : getSettingsColors(theme).input, borderRadius: '8px', minHeight: 40},
    '& .MuiAutocomplete-root .MuiOutlinedInput-root': {bgcolor: theme => theme.palette.mode === 'light' ? theme.palette.background.paper : getSettingsColors(theme).input},
    '& .MuiOutlinedInput-input': {...settingsInputStyles['& .MuiOutlinedInput-input'], fontSize: 13},
    '& .MuiButton-root': {textTransform: 'none', borderRadius: '8px', boxShadow: 'none', minHeight: 38}
};

export const dateRangeFooterStyles = {
    px: {xs: 2, sm: 2.5}, py: 1.5, gap: 1,
    bgcolor: theme => getSettingsColors(theme).inset,
    '& .MuiOutlinedInput-root': {height: 36, minHeight: 36},
    '& .MuiOutlinedInput-input': {py: 0.75},
    '& .MuiButton-root': {height: 36, minHeight: 36}
};

export const dateRangeMenuProps = {PaperProps: {sx: {
    bgcolor: theme => getSettingsColors(theme).card, borderRadius: '12px',
    '& .MuiMenuItem-root': {fontSize: 13, minHeight: 36}
}}};

export function DateRangePickerHeader({title = 'Date range', description, onClose}) {
    return <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, px: {xs: 2, sm: 2.5}, pt: 2.5, pb: 2}}>
        <Box sx={{display: 'grid', placeItems: 'center', width: 36, height: 36, borderRadius: '10px', flexShrink: 0,
            color: 'primary.main', bgcolor: theme => alpha(theme.palette.primary.main, 0.1)}}><DateRangeOutlined fontSize="small"/></Box>
        <Box sx={{flex: 1, minWidth: 0}}>
            <Typography component="h2" sx={{fontWeight: 600, fontSize: 16}}>{title}</Typography>
            <Typography sx={{color: 'text.secondary', fontSize: 12, mt: 0.25}}>{description}</Typography>
        </Box>
        <IconButton onClick={onClose} aria-label="Close date picker" size="small" sx={{color: 'text.secondary', alignSelf: 'flex-start'}}><Close fontSize="small"/></IconButton>
    </Box>;
}

export function DateRangeSelection({startDate, endDate, focusedInput, onFocusChange}) {
    return <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1}}>
        {[['startDate', 'Start date', startDate], ['endDate', 'End date', endDate]].map(([key, label, value]) => <ButtonBase
            key={key} onClick={() => onFocusChange(key)} aria-label={`Choose ${label.toLowerCase()}`} aria-pressed={focusedInput === key}
            sx={{display: 'block', textAlign: 'left', px: 1, py: 0.75, borderRadius: '8px', minWidth: 0, border: '1px solid',
                borderColor: theme => focusedInput === key ? alpha(theme.palette.primary.main, 0.4) : 'transparent',
                bgcolor: theme => getSettingsColors(theme).inset,
                '&.Mui-focusVisible': {outline: '2px solid', outlineColor: 'primary.main'}}}>
            <Typography component="span" sx={{display: 'block', fontSize: 11, color: 'text.secondary', mb: 0.25}}>{label}</Typography>
            <Typography component="span" sx={{fontSize: 13, fontWeight: 600, color: value ? 'text.primary' : 'text.secondary'}}>
                {value && moment(value).isValid() ? moment(value).format('D MMM YYYY') : 'Select date'}
            </Typography>
        </ButtonBase>)}
    </Box>;
}
